
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/google-bigquery",
      function () {
        return require("private-next-pages/destinations/google-bigquery.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/google-bigquery"])
      });
    }
  